<template>
  <div class="product-selector-info recharge-info">
    <div class="section-heading">
      <h3>Recharge Info</h3>
    </div>

    <div class="top">
      <div class="col col-12 info-item price" v-if="hasProducts">
        <div class="row">
          <div class="col col-xs-12">
            <label>
              Pay Now {{ orderTotal | currency }}              
            </label>
          </div>
        </div>
      </div>
      <div class="col col-12 info-item" v-if="!hasProducts">
        <div class="row">
          <div class="col col-xs-12">
            <label>
              Please select products to recharge.
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom info-details">

      <div 
      class="col col-12 info-item recharge-info"
        v-for="product in products"
        v-bind:key="product.id"
      >
        <div class="row">
          <div class="col col-xs-12">
            <label>{{ product.name + " " + product.type }}</label>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "recharge-info",
  props: ["products"],
  computed: {    
    orderTotal() {
      var self = this;     
      var total = 0; 
      self.products.forEach(function (value) {
        total += value.price;
      });
      return total;
    },
    hasProducts() {
      var self = this;
      return !self.isEmpty(self.products) || self.products.length > 0;
    }
  },
  methods: {
    isEmpty: function(data) {
      return data == null || typeof (data) == 'undefined' || Object.keys(data).length === 0;
    }
  }
};
</script>